import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-ellipsis-loader',
    imports: [],
    styleUrls: ['./ellipsis-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './ellipsis-loader.component.html',
})
export class EllipsisLoaderComponent {}
